module.exports = __webpack_public_path__ + "img/3.0.03cb8c51.jpg";